import { render, staticRenderFns } from "./TagsContainer.vue?vue&type=template&id=d9501ba6&scoped=true&"
import script from "./TagsContainer.vue?vue&type=script&lang=js&"
export * from "./TagsContainer.vue?vue&type=script&lang=js&"
import style0 from "./TagsContainer.vue?vue&type=style&index=0&id=d9501ba6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9501ba6",
  null
  
)

export default component.exports